import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpcenterDetailsItem: {
        defaultMessage: 'Help center details',
        description: 'Label for the help center details item in the help center management screen sidebar',
        id: 'admin.management.sidebar.edit.details.non-final',
    },
    helpcenterManageProjectsItem: {
        defaultMessage: 'Help center projects',
        description: 'Label for the help center projects item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects.non-final',
    },
    helpcenterVsaReportingItem: {
        defaultMessage: 'Virtual service agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting.non-final',
    },
    helpcenterVaReportingItem: {
        defaultMessage: 'Virtual agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting-old.non-final',
    },
});
